// Libraries
import { csvParse, DSVParsedArray } from 'd3-dsv';

// Types
import { ChartData, CSVColumn, MinMax } from '@/types';
import { max, mean, min } from 'd3-array';

export const onScatterFileLoad = (opts: {
  csv: string;
  setData: (arr: ChartData[]) => void;
  setDataMean: (num: (number | undefined)[]) => void;
  setDataMinMax: (minMax: MinMax[]) => void;
}) => {
  const { csv, setData, setDataMean, setDataMinMax } = opts;
  const meanArr: (number | undefined)[] = [];
  const minMaxArr: MinMax[] = [];

  const parsedCSV = Array.from(
    (csvParse(csv) as DSVParsedArray<CSVColumn>).sort((a, b) => {
      const fa = (a.Estado || '').toLowerCase();
      const fb = (b.Estado || '').toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    })
  );

  if (parsedCSV && parsedCSV.length > 0) {
    const columnValues: ChartData[] = [];

    // Separo las gráficas por columnas del CSV
    Object.keys(parsedCSV[0]).forEach((k) => {
      if (k !== 'Estado') {
        columnValues.push({
          chart: k,
          values: [],
        });
      }
    });

    // Agrupo los valores de la gráfica por factor por estado
    columnValues.forEach((el) => {
      const mapped: { id: string; x: number; y: number }[] = [];
      const numbersArr = parsedCSV.map((v) => Number(v[el.chart]));

      meanArr.push(Number((mean(numbersArr) || 0).toFixed(2)));

      minMaxArr.push({
        max: max(numbersArr),
        min: min(numbersArr),
      });

      for (let i = 0; i < parsedCSV.length; i += 1) {
        if (mapped.length === 0) {
          mapped.push({
            id: parsedCSV[i].Estado || '',
            x: Number(parsedCSV[i][el.chart]),
            y: 1,
          });
        } else {
          const freqIndex = mapped
            .map((m) => m.x)
            .lastIndexOf(Number(parsedCSV[i][el.chart]));

          if (freqIndex !== -1) {
            mapped.push({
              id: parsedCSV[i].Estado || '',
              x: Number(parsedCSV[i][el.chart]),
              y: mapped[freqIndex].y + 1,
            });
          } else {
            mapped.push({
              id: parsedCSV[i].Estado || '',
              x: Number(parsedCSV[i][el.chart]),
              y: 1,
            });
          }
        }
      }

      const sortedMap = mapped.sort((a, b) => a.x - b.x);

      el.values = sortedMap.map(({ id, x, y }) => ({
        id,
        data: [
          {
            x,
            y,
          },
        ],
      }));
    });

    setData(columnValues);
    setDataMean(meanArr);
    setDataMinMax(minMaxArr);
  }
};
